import { render } from "./IconItem.vue?vue&type=template&id=dfa861ae&scoped=true"
import script from "./IconItem.vue?vue&type=script&lang=js"
export * from "./IconItem.vue?vue&type=script&lang=js"

import "./IconItem.vue?vue&type=style&index=0&id=dfa861ae&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dfa861ae"

export default script